import { PlayLayout } from '@app/play-now/routes/PlayLayout';
import { setupPlayUtils } from '@app/play-now/routes/remix-route-helper';
import { ClientMetaFunction, mergeMeta } from '@app/utils/remix/play-now-meta';
import { searchMedia } from '@play-now/core/api/media-search/search-media';
import { searchShows } from '@play-now/core/api/show-search/search-shows';
import { MediaType } from '@play-now/core/models/MediaType';
import { getRemixMeta } from '@play-now/video/components/Meta/PlayMetaData';
import { useInitialData } from '@play-now/video/config/VideoAppContext';
import { SearchPage } from '@play-now/video/pages/Search/SearchPage';
import { json, LoaderFunctionArgs } from '@remix-run/node';
import { useLoaderData } from '@remix-run/react';

export const loader = async (args: LoaderFunctionArgs) => {
  const { config, axios, query } = setupPlayUtils(args);
  const [mediaResult, showResult] = await Promise.all([
    searchMedia(axios, {
      ...query,
      searchTerm: query.query || '',
      mediaType: (query.mediaType as MediaType) || 'VIDEO',
      includeAggregations: query.includeAggregations === 'true' || false,
    }),
    searchShows(axios, query.query),
  ]);

  const metaData = getRemixMeta({ config, allowIndexing: false });

  return json({ mediaResult, showResult, meta: metaData });
};

export const meta: ClientMetaFunction<typeof loader> = ({ data, matches }) => mergeMeta({ data, matches });
export const shouldRevalidate = () => false;

// Exporting an empty client loader enables instant client-side navigation.
export const clientLoader = async () => ({ mediaResult: undefined, showResult: undefined });

const SearchPageRoute = () => {
  const search = useLoaderData<typeof loader>();
  const initialData = useInitialData();
  return (
    <PlayLayout pageId='search'>
      <SearchPage initialData={{ ...initialData, search }} />
    </PlayLayout>
  );
};

export default SearchPageRoute;
